export const app_on_off_en = {
  true: 'On',
  false: 'Off',
};
